// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","logMessageLoading":"LogMessageLoading__logMessageLoading--uF","runningText":"LogMessageLoading__runningText--Do"};